const style = document.createElement("style");
style.innerHTML = `
    .default-button {
        all: unset;
        display: inline-block;
        cursor: pointer;
        color: #666666;
        font-size: 14px;
        font-weight: 500;
        white-space: nowrap;
        flex: 1;
        padding: 4px 8px;
    }
`;
document.head.appendChild(style);

// 版本固定的 CDN 檔案加上子資源完整性（SRI）檢查，CDN 內容遭竄改時瀏覽器會拒絕執行（2026 資安健診）。
// 來源使用 jsdelivr：code.highcharts.com 官方不建議用於正式環境，且會間歇性以 403 阻擋請求。
// Highstock 12.6.2（< 9.0.0 有 XSS 弱點 CVE-2021-29489，2026 資安健診 PT-04）：jsdelivr 檔案與 npm 套件
// 逐位元組相同，SHA-256 與 jsdelivr 公布值（data.jsdelivr.com）一致。
const HIGHSTOCK_SRC =
  "https://cdn.jsdelivr.net/npm/highcharts@12.6.2/highstock.js";
const HIGHSTOCK_INTEGRITY =
  "sha384-LpM0DFt42QN6hdQeYSZZQs3PSR+ExTQgF2BcAIudpOBQ5vwXHaE5dTi2cr/IACn9";

// Highcharts 8 的預設外觀。Highcharts 11 全面更新預設樣式（字級改用 em、字型、軸線、tooltip），
// 12 起日期改由 Intl 依頁面語系產生（月份會從「Oct」變成「10月」）；
// 這裡只還原淨值走勢圖用得到的部分，讓升級只修補弱點、不改變圖表外觀。數值取自 highcharts@8.2.0。
const V8_AXIS_LOOK = {
  dateTimeLabelFormats: {
    millisecond: { main: "%H:%M:%S.%L", range: false },
    second: { main: "%H:%M:%S", range: false },
    minute: { main: "%H:%M", range: false },
    hour: { main: "%H:%M", range: false },
    day: { main: "%e. %b" },
    week: { main: "%e. %b" },
    month: { main: "%b '%y" },
    year: { main: "%Y" },
  },
  labels: { style: { color: "#666666", fontSize: "11px" } },
  title: { style: { color: "#666666", fontSize: "12px" } },
  lineColor: "#ccd6eb",
  tickColor: "#ccd6eb",
};
const V8_DEFAULT_LOOK = {
  chart: {
    style: {
      fontFamily:
        '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',
      fontSize: "12px",
    },
  },
  // v12 的 x 軸標籤與軸線距離預設 15px，v8 實測為 8px（繪圖區因此矮約 7px）；y 軸兩版同為 15px
  xAxis: { ...V8_AXIS_LOOK, labels: { ...V8_AXIS_LOOK.labels, distance: 8 } },
  yAxis: V8_AXIS_LOOK,
  tooltip: {
    backgroundColor: "rgba(247,247,247,0.85)",
    borderWidth: 1,
    shadow: true,
    style: { color: "#333333", fontSize: "12px", whiteSpace: "nowrap" },
    headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>',
    dateTimeLabelFormats: {
      millisecond: "%A, %b %e, %H:%M:%S.%L",
      second: "%A, %b %e, %H:%M:%S",
      minute: "%A, %b %e, %H:%M",
      hour: "%A, %b %e, %H:%M",
      day: "%A, %b %e, %Y",
      week: "Week from %A, %b %e, %Y",
      month: "%B %Y",
      year: "%Y",
    },
  },
  plotOptions: {
    series: {
      // 資料分組（期間較長時）後 tooltip 標頭使用的日期格式
      dataGrouping: {
        dateTimeLabelFormats: {
          millisecond: [
            "%A, %b %e, %H:%M:%S.%L",
            "%A, %b %e, %H:%M:%S.%L",
            "-%H:%M:%S.%L",
          ],
          second: ["%A, %b %e, %H:%M:%S", "%A, %b %e, %H:%M:%S", "-%H:%M:%S"],
          minute: ["%A, %b %e, %H:%M", "%A, %b %e, %H:%M", "-%H:%M"],
          hour: ["%A, %b %e, %H:%M", "%A, %b %e, %H:%M", "-%H:%M"],
          day: ["%A, %b %e, %Y", "%A, %b %e", "-%A, %b %e, %Y"],
          week: ["Week from %A, %b %e, %Y", "%A, %b %e", "-%A, %b %e, %Y"],
          month: ["%B %Y", "%B", "-%B %Y"],
          year: ["%Y", "%Y", "-%Y"],
        },
      },
    },
  },
  lang: {
    // v8 的千分位為空白、小數點為「.」；v12 未設定時改依頁面語系（zh-TW 為「,」）
    thousandsSep: " ",
    decimalPoint: ".",
    shortMonths: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
  },
  // 拖曳縮放（zoomType: "x"）後出現的「Reset zoom」按鈕字級
  global: { buttonTheme: { style: { fontSize: "12px" } } },
};

// 如果已經有 Highcharts 但沒有 stockChart，我們需要先移除現有的 Highcharts
if (window.Highcharts && !window.Highcharts.stockChart) {
  window.Highcharts = undefined;
}

window.HighchartsInit = {
  promise: null,
  instance: null,
  load: function () {
    if (this.promise) {
      return this.promise;
    }

    this.promise = new Promise((resolve, reject) => {
      if (window.Highcharts && window.Highcharts.stockChart) {
        this.instance = window.Highcharts;
        resolve(this.instance);
        return;
      }

      const script = document.createElement("script");
      script.src = HIGHSTOCK_SRC;
      // SRI 需以 CORS 模式取得資源，否則瀏覽器會直接拒絕執行
      script.integrity = HIGHSTOCK_INTEGRITY;
      script.crossOrigin = "anonymous";

      script.onload = () => {
        if (window.Highcharts && window.Highcharts.stockChart) {
          this.instance = window.Highcharts;
          resolve(this.instance);
        } else {
          this.promise = null;
          reject(
            new Error("Highcharts.stockChart not available after loading")
          );
        }
      };

      script.onerror = () => {
        this.promise = null;
        reject(new Error("Failed to load Highstock"));
      };

      document.head.appendChild(script);
    });

    return this.promise;
  },
};

let Highcharts = window.HighchartsInit.instance;

const initHighchartsLoad = () => {
  return window.HighchartsInit.load()
    .then((instance) => {
      Highcharts = instance;
      // 檢查函數是否存在
      if (typeof loadScript === "function") {
        loadScript();
      }
      if (typeof randerNavRangeButtons === "function") {
        randerNavRangeButtons();
      }
      return instance;
    })
    .catch((error) => {
      console.error("Failed to initialize Highstock:", error);
    });
};

initHighchartsLoad();

// url參數
let scriptId = document.getElementById("fundNavChartScript");

let mfxId = scriptId?.getAttribute("mfx-id") || "IV16";

let startDate = new Date(new Date().setMonth(new Date().getMonth() - 12))
  .toLocaleDateString()
  .replace(/\//g, "-");
let endDate = new Date().toLocaleDateString().replace(/\//g, "-");

// 初始化圖表
function initChart() {
  // 同時取得基金詳細資料和導航圖表資料
  Promise.all([getFundDetail(), getNavChartData()])
    .then(([fundDetailData, navChartData]) => {
      // 檢查導航圖表數據是否有效
      if (!navChartData || !navChartData.nav || !navChartData.nav.length) {
        console.warn("數據為空，無法渲染圖表。");
        return;
      }

      // 處理基金詳細資料（根據您的需求使用）
      if (fundDetailData) {
        const fundShortNameElement = document.getElementById("fund-short-name");
        if (fundShortNameElement && fundDetailData.fundShortName) {
          const name = fundDetailData.fundShortName;
          const warning = fundDetailData.warningWarning;
          // 以 textContent 組合，資料中的 HTML 不會被當成標籤執行
          fundShortNameElement.textContent = name;
          if (warning) {
            const warningElement = document.createElement("span");
            warningElement.style.fontWeight = "bold";
            warningElement.textContent = `(${warning})`;
            fundShortNameElement.appendChild(warningElement);
          }
        }
      }

      // 數據轉換（根據實際 API 格式調整）
      const navData = navChartData.nav.map((item) => [
        Date.parse(item.date), // 假設日期字段為 item.date
        item.value, // 假設值字段為 item.value
      ]);

      const maD20Data = navChartData.maD20.map((item) => [
        Date.parse(item.date), // 假設日期字段為 item.date
        item.value, // 假設值字段為 item.value
      ]);

      const maD240Data = navChartData.maD240.map((item) => [
        Date.parse(item.date), // 假設日期字段為 item.date
        item.value, // 假設值字段為 item.value
      ]);

      // 組織圖表數據
      const chartData = [
        {
          name: "本基金",
          data: navData,
          color: "#FF9664", // 可以根據需求自定義顏色
          lineWidth: 3,
        },
        {
          name: "20 均線",
          data: maD20Data,
          color: "#5995F7", // 可以根據需求自定義顏色
          lineWidth: 1,
        },
        {
          name: "240 均線",
          data: maD240Data,
          color: "#6FDDDA", // 可以根據需求自定義顏色
          lineWidth: 1,
        },
      ];

      // 渲染圖表
      renderChart(chartData);

      const latestDate = navChartData.nav[navChartData.nav.length - 1].date;
      const updateDate = document.getElementById("latest-date");
      updateDate.textContent = `${latestDate} 更新`;
    })
    .catch((error) => {
      console.error("圖表初始化失敗:", error);
    });
}

function renderChart(chartData) {
  Highcharts.setOptions(V8_DEFAULT_LOOK);
  Highcharts.setOptions({
    time: {
      useUTC: false,
    },
    lang: {
      weekdays: [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ],
      months: [
        "一月",
        "二月",
        "三月",
        "四月",
        "五月",
        "六月",
        "七月",
        "八月",
        "九月",
        "十月",
        "十一月",
        "十二月",
      ],
    },
  });
  Highcharts.stockChart("nav-chart-container", {
    chart: {
      type: "line",
      height: "300px",
      zoomType: "x",
      panning: true,
      panKey: "shift",
    },
    credits: {
      enabled: false,
    },
    accessibility: {
      enabled: false, // 關閉可接近性模組
    },
    tooltip: {
      pointFormat: `<span style="color:{point.color}">●</span><b> ${"{point.y}"}</b><br/>`,
      dateTimeLabelFormats: {
        day: "%A, %B %e, %Y",
      },
      xDateFormat: "%A, %B %e, %Y",
    },
    plotOptions: {
      series: {
        dataGrouping: {
          dateTimeLabelFormats: {
            week: ["%A, %B %e, %Y"],
          },
        },
      },
    },
    xAxis: {
      labels: {
        style: {
          fontSize: "14px",
        },
      },
    },
    navigator: {
      enabled: false,
      maskFill: "rgba(255, 150, 100, .15)",
    },
    scrollbar: {
      enabled: false,
    },
    rangeSelector: {
      enabled: false,
    },
    series: chartData, // 使用處理後的 chartData
  });
}

function randerNavRangeButtons() {
  const buttons = document.getElementById("nav-range-buttons");
  const ranges = [
    { label: "3個月", months: 3 },
    { label: "6個月", months: 6 },
    {
      label: "今年",
      custom: () => {
        const now = new Date();
        const yearStart = new Date(now.getFullYear(), 0, 1);
        const startDate = yearStart.toLocaleDateString().replace(/\//g, "-");
        const endDate = now.toLocaleDateString().replace(/\//g, "-");
        return [startDate, endDate];
      },
    },
    { label: "1年", months: 12 },
    { label: "2年", months: 24 },
    { label: "3年", months: 36 },
    { label: "5年", months: 60 },
  ];
  ranges.forEach((range) => {
    const button = document.createElement("button");
    button.textContent = range.label;
    button.className = "default-button";

    if (range.months === 12) {
      // 預設顯示 1 年
      button.style.color = "#FF9664";
    }

    button.onclick = () => {
      buttons.querySelectorAll(".default-button").forEach((btn) => {
        btn.style.color = "#666666";
      });

      button.style.color = "#FF9664";
      const now = new Date();
      if (range.custom) {
        // 自定義計算日期範圍
        [startDate, endDate] = range.custom();
      } else {
        // 根據 months 計算日期範圍
        const start = new Date();
        start.setMonth(now.getMonth() - range.months);
        startDate = start.toLocaleDateString().replace(/\//g, "-");
        endDate = now.toLocaleDateString().replace(/\//g, "-");
      }

      initChart(); // 重新初始化圖表
    };

    buttons.appendChild(button);
  });
}

function getNavChartData() {
  let url = `https://${window.location.host}/next/api/funds/detail/${mfxId}/nav-chart?startDate=${startDate}&endDate=${endDate}&dma=20,240`;
  return fetch(url)
    .then((response) => {
      // 檢查回應是否成功
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json(); // 將回應轉換為 JSON 格式
    })
    .catch((error) => {
      // 捕獲並處理錯誤
      console.error("發生錯誤:", error);
    });
}

// 取得基金詳細資料
function getFundDetail() {
  const url = `https://${window.location.host}/next/api/funds/detail/${mfxId}`;
  return fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .catch((error) => {
      console.error("取得基金詳細資料時發生錯誤:", error);
      throw error;
    });
}

function loadScript() {
  const container = document.createElement("div");
  container.innerHTML = `
    <div>
        <div id="fund-short-name" style="font-size: 18px; color: #333333; font-weight: 500;">
        </div>
        <div style="font-size: 18px; color: #333333; font-weight: 500; margin-bottom: 16px;">
            淨值走勢
            <span id="latest-date" style="font-size: 14px; color: #999999"></span>
        </div>
        <div id="nav-range-buttons" style="display: flex; max-width: 600px;"></div>
        <div id="nav-chart-container" style="width: 100%; height: 300px;"></div>
        <div style="display: flex; align-items: center; margin-top: 8px;">
            <div style="display: flex; align-items: center; margin-right: 16px;">
                <div style="width: 16px; height: 16px; border-radius: 4px; background: #FF9664; margin-right: 8px;"></div>
                <span style="color: #666666; font-size: 14px">本基金</span>
            </div>
            <div style="display: flex; align-items: center; margin-right: 16px;">
                <div style="width: 16px; height: 16px; border-radius: 4px; background: #5995F7; margin-right: 8px;"></div>
                <span style="color: #666666; font-size: 14px">20 日均線</span>
            </div>
            <div style="display: flex; align-items: center; margin-right: 16px;">
                <div style="width: 16px; height: 16px; border-radius: 4px; background: #6FDDDA; margin-right: 8px;"></div>
                <span style="color: #666666; font-size: 14px">240 日均線</span>
            </div>
        </div>
        <div style="font-size: 14px; margin-top: 16px; background: #f5f5f5; padding: 16px; border-radius: 4px;">資料來源：好好證券彙整，詳見重要聲明。</div>
    </div>
    `;

  const targetElement = document.getElementById("fundNavChartScript");
  targetElement.innerHTML = "";
  targetElement.appendChild(container);

  initChart();
}
